import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environments/_current/environment';
import { VERSION } from '@environments/version';
import { init, setTag } from '@sentry/angular';
import { captureConsoleIntegration } from '@sentry/browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

async function prepareApp() {
  if (environment.productionMode) {
    enableProdMode();

    init({
      dsn: environment.sentryDsn,
      environment: environment.serverEnvironment,
      release: `${environment.sentryServiceTag}@${VERSION.version}`,
      integrations: [
        captureConsoleIntegration({
          levels: ['warn', 'error', 'debug'],
        }),
      ],
    });

    setTag('service', environment.sentryServiceTag);
  }

  return Promise.resolve();
}

prepareApp().then(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
  );
});
